import { render, staticRenderFns } from "./InheritedValueHint.vue?vue&type=template&id=d3244b28&scoped=true&lang=pug&"
import script from "./InheritedValueHint.vue?vue&type=script&lang=js&"
export * from "./InheritedValueHint.vue?vue&type=script&lang=js&"
import style0 from "./InheritedValueHint.vue?vue&type=style&index=0&id=d3244b28&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3244b28",
  null
  
)

/* custom blocks */
import block0 from "./InheritedValueHint.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports